import Cookies from "js-cookie";
import { useFetchData } from "utils/ReactQueryHooks";
import { isData } from "utils/HookResponse";
import { ApiResponseData } from "types/common";

export const useOemModelIds = (deviceCode: string) =>
  useFetchData({
    key: "useOemModelIds",
    url: "firmwares/model-ids",
    headers: {
      aId: Cookies.get("aId"),
      "device-code": deviceCode,
    },
    options: {
      enabled: false,
      select: (data: ApiResponseData) => [...new Set(isData(data))],
    },
  });
